import React, { useMemo } from 'react';
import styles from './Footer.module.scss';
import { getClassName } from '@onsolve/utils.get-class-name';
import { t } from '@lingui/macro';
import MFELink from '@components/MFELink/MFELink';
import configService from '@services/config.service';
import { useAccountContext } from '@context/AccountContext';
const Footer = () => {
    const [rootClass, getChildClass] = getClassName({
        rootClass: 'footer',
        styles,
    });
    const { brand = '' } = useAccountContext();
    const { RightToBeForgottenBaseUrl = '' } = configService;
    const canViewWTPCustomer = brand === 'wtp';
    const isCodeRedOrg = brand === 'codered';
    const isResponsePortal = window.location.pathname === '/response';
    const privacyAndCopyrightUrl = isCodeRedOrg || isResponsePortal
        ? 'https://codered.crisis24.com/legal/privacy-notice-and-terms-of-use'
        : 'https://www.crisis24.com/legal/privacy-policy';
    const rightToBeForgottenUrl = useMemo(() => {
        const returnUrl = window.location.origin;
        return `${RightToBeForgottenBaseUrl}/onsolve/en-us?returnUrl=${returnUrl}`;
    }, []);
    return (<footer className={rootClass}>
            <div className="onsolve-footer__copyright">
                {isCodeRedOrg ? (<span>&copy; Crisis24 {new Date().getFullYear()}</span>) : (<span>&copy; {new Date().getFullYear()} OnSolve</span>)}
            </div>

            <div className={getChildClass('right')}>
                <ul className={getChildClass('links-list')}>
                    {!canViewWTPCustomer ? (<>
                            <li role="menuitem" className={getChildClass('links-item')}>
                                <a className="onsolve-footer__link" target={'_blank'} href={isCodeRedOrg || isResponsePortal
                ? 'http://codered.crisis24.com'
                : 'https://www.onsolve.com'} rel="noreferrer">
                                    {isCodeRedOrg || isResponsePortal ? 'codered.crisis24.com' : 'www.onsolve.com'}
                                </a>
                            </li>
                            <li role="menuitem" className={getChildClass('links-item')}>
                                <a title={t `Data Subject Rights Request`} className={styles.anchor} href={rightToBeForgottenUrl}>
                                    {t `Data Subject Rights Request`}
                                </a>
                            </li>
                            <li role="menuitem" className={getChildClass('links-item')}>
                                <a title={t `Onsolve Privacy`} className={styles.anchor} href={privacyAndCopyrightUrl}>
                                    {t `Privacy Statement`}
                                </a>
                            </li>
                        </>) : (<>
                            <li role="menuitem" className={getChildClass('links-item')}>
                                <a title={t `Powered by OnSolve`} className={styles.anchor} href="https://www.onsolve.com/">
                                    {t `Powered by OnSolve`}
                                </a>
                            </li>
                            <li role="menuitem" className={getChildClass('links-item')}>
                                <a title={t `World Travel Protection Data Subject Rights Request`} className={styles.anchor} href="https://gdpr.onsolve.net/wtp/en-us/">
                                    {t `Data Subject Rights Request`}
                                </a>
                            </li>
                            <li role="menuitem" className={getChildClass('links-item')}>
                                <a title={t `World Travel Protection Privacy Statement`} className={styles.anchor} href="https://worldtravelprotection.com/privacy-policy/">
                                    {t `Privacy Statement`}
                                </a>
                            </li>
                        </>)}
                    <li role="menuitem" className={getChildClass('links-item')}>
                        <a className="onsolve-footer__link" target={'_blank'} href={privacyAndCopyrightUrl} rel="noreferrer">
                            {t `Copyright Notice`}
                        </a>
                    </li>
                    <li role="menuitem" className={getChildClass('links-item')}>
                        <MFELink title={t `Onsolve's Contact`} className={styles.anchor} requiresJWT={false} to={'/contact-us'}>
                            {t `Contact Us`}
                        </MFELink>
                    </li>
                </ul>
            </div>
        </footer>);
};
export default Footer;
